export default {
    namespaced: true,
    state: {
        materials: [],
        supplierMaterials: [],
        errors: {
            getMaterials: ''
        }
    },
    getters: {
        //values for supplier products page filter, default all
        supplierMaterialsValuesArr(state) {
            return state.supplierMaterials.map(material => material.MaterialID)
        }
    },
    mutations: {
        SET_MATERIALS(state, payload) {
            state.materials = payload
        },
        SET_SUPPLIER_MATERIALS(state, payload) {
            state.supplierMaterials = payload
        },
        SET_ERRORS(state, error) {
            state.errors[error.key] = error.val
        }
    },
    actions: {
        async getMaterials({ commit }, data) {
            commit('SET_ERRORS', {
                key: 'getMaterials',
                val: ''
            })

            const url = '/public/dict/materials'

            try {
                const resp = await this.$axios
                    .get(url, {
                        params: data
                    })
                    .then(res => {
                        return res.data
                    })

                if (data && data.existing) {
                    commit('SET_SUPPLIER_MATERIALS', resp)
                } else {
                    commit('SET_MATERIALS', resp)
                }
            } catch (e) {
                if (e.response) {
                    console.log(e.response.data)
                    commit('SET_ERRORS', {
                        key: 'getMaterials',
                        val: e.response.data
                    })
                } else {
                    console.log('Ошибка ' + e.message)
                    commit('SET_ERRORS', {
                        key: 'getMaterials',
                        val: 'Ошибка'
                    })
                }
            }
        }
    }
}
